<!--<div class="panel" *ngIf="!loadingImpressions && !loadingReport">-->
<h2 class="mb-s p-0">Banner {{ ad.title }}</h2>
<!--<hr class="mb-l">-->
<div class="row mb-xl">
  <div class="col-2">
    <div class="mb-l">
      <strong>Buchung</strong>
      <p>{{ad.title}}</p>
    </div>
    <div class="mb-l">
      <strong>Werbeform</strong>
      <p>{{getAdLocation(ad.location)}}</p>
    </div>
    <div class="mb-l">
      <strong>Zeitraum</strong>
      <p>{{getDate(ad.start) | date: 'dd.MM.yyyy'}} - <br>{{getDate(ad.end) | date: 'dd.MM.yyyy'}}</p>
    </div>
  </div>
  <div class="col-10"><div class="image-container"><img src="{{ CDN }}/marketing-management/{{ad.image}}" alt="{{ ad.title }}"/></div></div>

</div>

<h2 class="mb-s p-0">Performance</h2>
<hr class="mb-xl">
<div class="performance-ad pt-xxl" id="{{ad.id}}" [attr.data-click]="click" [attr.data-group]="group" [attr.data-view]="view" [attr.data-view-perc]="viewPerc" [attr.data-type]="getAdLocation(ad.location)">
  <div class="row">
    <div class="col-2">
      Click-performance
    </div>
    <div class="col-10">
      <div class="click w-100 mb-l">
        <div class="d-flex">
          <div class="vis-1">
            @if (click <= 1) {
              <div class="marker" [style.left]="click * 100 + '%'">
                <div class="value d-flex flex-column text-center">
                  <small>{{ selectedClicks }}</small>
                  <mat-icon>arrow_drop_down</mat-icon>
                </div>
              </div>
            }
          </div>
          <div class="vis-2">
            @if (click > 1) {
              <div class="marker" [style.left]="((click-1)/click) * 100 + '%'">
                <div class="value d-flex flex-column text-center">
                  <small>{{ selectedClicks }}</small>
                  <mat-icon>arrow_drop_down</mat-icon>
                </div>
              </div>
            }
          </div>
        </div>
        <div class="d-flex">
          <div class="red"></div>
          <div class="yellow"></div>
          <div class="green"></div>
        </div>
      </div>
    </div>
  </div>

  @if (group > 0) {
    <div class="row">
      <div class="col-2">
        Zielgruppe
      </div>
      <div class="col-10">
        <div class="group w-100 mb-l">
          <div class="marker" [style.left]="groupPercent*100 + '%'">
            <div class="value d-flex flex-column text-center">
              <small>{{ group * 100 }}%</small>
              <mat-icon>arrow_drop_down</mat-icon>
            </div>
          </div>
          <div class="d-flex">
            <div class="red"></div>
            <div class="yellow"></div>
            <div class="green"></div>
          </div>
        </div>
      </div>
    </div>
  }
  <div class="row">
    <div class="col-2">
      Sichtbarkeit
    </div>
    <div class="col-10">
      <div class="view w-100">
        <div class="d-flex">
          <div class="vis-1">
            @if (viewPerc <= 1) {
              <div class="marker" [style.left]="viewPerc * 100 + '%'">
                <div class="value d-flex flex-column text-center">
                  <small>{{ view }}</small>
                  <mat-icon>arrow_drop_down</mat-icon>
                </div>
              </div>
            }
          </div>
          <div class="vis-2">
            @if (viewPerc > 1) {
              <div class="marker" [style.left]="((viewPerc-1)/viewPerc) * 100 + '%'">
                <div class="value d-flex flex-column text-center">
                  <small>{{ view }}</small>
                  <mat-icon>arrow_drop_down</mat-icon>
                </div>
              </div>
            }
          </div>
        </div>
        <div class="d-flex">
          <div class="red"></div>
          <div class="yellow"></div>
          <div class="green"></div>
        </div>
      </div>
    </div>
  </div>
</div>
